import Titlesection from './TitleSection';
import { SIZE } from './constants';

export default Titlesection;
export { SIZE };